module.exports = __webpack_public_path__ + "static/media/logo-with-text-grey.b88dae38.svg";